import React, { useRef, useEffect, memo } from 'react'
import Section from '../filters/Section/Section.jsx'

const Sidebar = ({view}) => {
  const sidebarRef = useRef(null);

  const handleMobileToggle = () => {
    sidebarRef.current.classList.toggle('c-searchSidebar--mobileOpen');
  };
  
  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    const handleMediaChange = (event) => {
      if (event.matches) {
        sidebarRef.current && sidebarRef.current.classList.remove('c-searchSidebar--mobileOpen');
      }
    };
    mediaQuery.addEventListener('change', handleMediaChange);
    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, []);

  return (
    <div
      ref={sidebarRef}
      className={`c-searchSidebar l-box l-box--gold ${view === 'map' ? 'd-none' : ''}`}
    >
      <button className="c-searchSidebar__mobileHeader js-searchSidebar__mobileHeader" type="button" onClick={handleMobileToggle}>
        <span>Search and filters</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
        </svg>
      </button>
      <div className="c-searchSidebar__body">
        {
          <>
            <Section
              title='Your selections'
              filtersId='selections'
              type='selections'
            />
          <hr className="h-hr--small"/>
          </>
        }
        <Section
          filtersId='search'
          type='search'
          title="Search terms"
        />
        <hr/>
        <Section
          filtersId='clubOffers'
          title='Club offer times'
          type='clubOffers'
        />
        <hr/>
        <Section
          filtersId='cuisines'
          title='Cuisine'
          type='checkboxes'
        />
        <hr/>
        <Section
          filtersId='awards'
          title='Awards'
          type='checkboxes'
        />
        <hr/>
        <Section
          filtersId='ambiences'
          title='Restaurant Style'
          type='checkboxes'
        />
        <hr/>
        <Section
          filtersId='privateDining'
          title='Private Dining'
          type='slider'
        />
      </div>
    </div>
  )
}

// function propsAreEqual(prev, next) {
//   return prev.filters === next.filters && prev.selections === next.selections && prev.view === next.view && next.loading
// }

// export default memo(Sidebar, propsAreEqual);
export default Sidebar